// API Constants
import { getApiUrl } from '../../config/apiConfig';

export const API_BASE_URL = getApiUrl();

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  TEACHER: 'teacher',
  STUDENT: 'student'
};

// Status Constants
export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  SUSPENDED: 'suspended'
};

// Message Types
export const MESSAGE_TYPES = {
  MESSAGE: 'message',
  REPLY: 'reply',
  NOTIFICATION: 'notification',
  SYSTEM: 'system'
};

// Message Priorities
export const MESSAGE_PRIORITIES = {
  LOW: 'low',
  NORMAL: 'normal',
  HIGH: 'high',
  URGENT: 'urgent'
};

// Course Status
export const COURSE_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived'
};

// Lesson Types
export const LESSON_TYPES = {
  VIDEO: 'video',
  TEXT: 'text',
  PDF: 'pdf',
  QUIZ: 'quiz',
  ASSIGNMENT: 'assignment'
};

// Video Sources
export const VIDEO_SOURCES = {
  BUNNY: 'bunny',
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  UPLOAD: 'upload',
  EXTERNAL: 'external'
};

// Subscription Status
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
  PENDING: 'pending'
};

// Payment Status
export const PAYMENT_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  REFUNDED: 'refunded'
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
  DEFAULT_PAGE: 1
};

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'DD MMM YYYY',
  INPUT: 'YYYY-MM-DD',
  DATETIME: 'DD MMM YYYY HH:mm',
  TIME: 'HH:mm'
};

// File Upload Limits
export const FILE_UPLOAD = {
  MAX_IMAGE_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_VIDEO_SIZE: 500 * 1024 * 1024, // 500MB
  MAX_PDF_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_VIDEO_TYPES: ['video/mp4', 'video/avi', 'video/mov', 'video/wmv'],
  ALLOWED_DOCUMENT_TYPES: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
};

// Validation Rules
export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 128,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 100,
  EMAIL_MAX_LENGTH: 255,
  TITLE_MIN_LENGTH: 3,
  TITLE_MAX_LENGTH: 255,
  DESCRIPTION_MAX_LENGTH: 2000,
  MESSAGE_MIN_LENGTH: 1,
  MESSAGE_MAX_LENGTH: 5000
};

// Theme Colors
export const COLORS = {
  PRIMARY: '#3B82F6',
  SECONDARY: '#10B981',
  SUCCESS: '#22C55E',
  WARNING: '#F59E0B',
  ERROR: '#EF4444',
  INFO: '#6366F1',
  GRAY: '#6B7280',
  LIGHT_GRAY: '#F3F4F6',
  DARK_GRAY: '#374151'
};

// Breakpoints
export const BREAKPOINTS = {
  SM: '640px',
  MD: '768px',
  LG: '1024px',
  XL: '1280px',
  '2XL': '1536px'
};

// Animation Durations
export const ANIMATIONS = {
  FAST: '150ms',
  NORMAL: '300ms',
  SLOW: '500ms'
};

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
  PREFERENCES: 'preferences'
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'حدث خطأ في الاتصال بالشبكة',
  UNAUTHORIZED: 'غير مصرح لك بالوصول',
  FORBIDDEN: 'ممنوع الوصول',
  NOT_FOUND: 'الصفحة غير موجودة',
  SERVER_ERROR: 'حدث خطأ في الخادم',
  VALIDATION_ERROR: 'خطأ في البيانات المدخلة',
  TIMEOUT: 'انتهت مهلة الاتصال',
  UNKNOWN_ERROR: 'حدث خطأ غير متوقع'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'تم تسجيل الدخول بنجاح',
  REGISTER_SUCCESS: 'تم إنشاء الحساب بنجاح',
  LOGOUT_SUCCESS: 'تم تسجيل الخروج بنجاح',
  PROFILE_UPDATED: 'تم تحديث الملف الشخصي بنجاح',
  PASSWORD_CHANGED: 'تم تغيير كلمة المرور بنجاح',
  MESSAGE_SENT: 'تم إرسال الرسالة بنجاح',
  MESSAGE_DELETED: 'تم حذف الرسالة بنجاح',
  COURSE_CREATED: 'تم إنشاء الدورة بنجاح',
  COURSE_UPDATED: 'تم تحديث الدورة بنجاح',
  LESSON_CREATED: 'تم إنشاء الدرس بنجاح',
  LESSON_UPDATED: 'تم تحديث الدرس بنجاح'
};

const constants = {
  API_BASE_URL,
  USER_ROLES,
  STATUS,
  MESSAGE_TYPES,
  MESSAGE_PRIORITIES,
  COURSE_STATUS,
  LESSON_TYPES,
  VIDEO_SOURCES,
  SUBSCRIPTION_STATUS,
  PAYMENT_STATUS,
  PAGINATION,
  DATE_FORMATS,
  FILE_UPLOAD,
  VALIDATION,
  COLORS,
  BREAKPOINTS,
  ANIMATIONS,
  STORAGE_KEYS,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES
};

export default constants;
